import React, { Component, useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import WTypography from '../../../../Components/whiteTypography'

function EAlimentationChart({ reports, setHeaderValue, setOpen }) {
  const [click, setClick] = useState(false)

  const [revdata, setRevData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
      },
    ],
  })

  const optionsbar = {
    indexAxis: 'x',
    aspectRatio: 1.3,
    scales: {
      x: {
        ticks: {
          color: 'white', // Couleur du texte pour les axes X
        },
        grid: {
          color: 'rgba(255,255,255,0.1)', // Optionnel: couleur des lignes de grille pour l'axe X
        },
      },
      y: {
        ticks: {
          color: 'white', // Couleur du texte pour les axes Y
        },
        grid: {
          color: 'rgba(255,255,255,0.1)', // Optionnel: couleur des lignes de grille pour l'axe Y
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      datalabels: { 
        color: 'white',
    },
      legend: {
        display: false,
      },

      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }

  useEffect(() => {
    getRavData()
  }, [reports])

  const getRavData = () => {
    let labels = []
    let data = []
    let sum = 0

    reports[0].byyear.length > 0 &&
      reports[0].byyear.map((item, i) => {
        labels.push(item.year)
        data.push(item.value)
        sum = sum + item.value
      })
    // setHeaderValue(sum)

    labels.length > 0 &&
      setRevData({
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
          },
        ],
      })
  }

  const HorizontalBarChart = () => (
    <>
      {reports && revdata.labels.length === 0 && revdata.datasets[0].data.length === 0 ? (
        <WTypography variant="h6" align="center" marginTop="8rem">
          Aucune donnée
          <WTypography
            variant="h6"
            onClick={() => setOpen(true)}
            sx={{ '&:hover': { cursor: 'pointer', textDecoration: 'underline' } }}
            align="center"
            marginTop="2rem"
          >
            Répondre aux questionnaires pour estimer votre empreinte liée al'alimentation
          </WTypography>
        </WTypography>
      ) : (
        <Bar data={revdata} height={'270%'} options={optionsbar} />
      )}
    </>
  )
  return (
    <>
      <HorizontalBarChart />
    </>
  )
}

export default EAlimentationChart
